import { SettingsGroup } from '../groups/SettingsGroup';
import { SettingsSectionType } from '../types';

export function SettingsSection(props: { section: SettingsSectionType }) {
    return (
        <div className="d-flex flex-column gap-2 settings-section-content" style={{ width: 'min(100%, 675px)' }}>
            {props.section.groups.map((x, i) => (
                <SettingsGroup key={i} group={x} />
            ))}
        </div>
    );
}
